import { createFileRoute, redirect } from "@tanstack/react-router";

// Index of the students section: redirect to the overview list (portal's `students._index`).
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/students/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/$school/students/overview",
      params: { locale: params.locale, schoolyear: params.schoolyear, school: params.school },
    });
  },
});
